/* eslint-disable no-unused-expressions */
import React, { Component } from 'react';

import { renderTableHeader, handleOkButtonClick } from './tableHelper';

import formFields from '../../util/formFields';

import './tables.css';

export class AccountResults extends Component {
  state = {
    selected: '',
  };

  renderTableBody(data) {
    return data.map((row, index) => {
      return (
        <tr
          data-value={index}
          className={'table-row'}
          key={index}
          onClick={e => {
            this.addRowHighlight(e);
          }}
        >
          {formFields.accountsListTableHeaders.map(column => {
            return <td key={column.text}>{row[column.dataField]}</td>;
          })}
        </tr>
      );
    });
  }

  addRowHighlight(e) {
    const { selected } = this.state;
    let selectedRow = e.target.parentElement;
    if (!selected) {
      selectedRow.className = 'highlight';
      this.setState(() => ({
        selected: selectedRow,
      }));
    }
  }

  removeRowHighlight(selected) {
    if (selected) {
      this.setState(() => ({
        selected: '',
      }));
      return (selected.className = 'table-row');
    }
  }

  render() {
    const { selected } = this.state;
    const { data, okButtonClick, removeAccount } = this.props;
    const { accountsListTableHeaders: headerData } = formFields;
    return (
      <div className="account-results-container">
        <h2 className="searchFormTitle">Customer Account Search Results: Select Account and Click Ok</h2>
        <div className="accounts-results-list-container">
          <table>
            <thead>
              <tr>{renderTableHeader(headerData)}</tr>
            </thead>
            <tbody>{this.renderTableBody(data)}</tbody>
          </table>
        </div>
        <div className="accounts-results-list-buttons-container">
          <button name="backButton" className="search-button" onClick={() => removeAccount()}>
            Back
          </button>
          <span className="float-right">
            <button
              name="okButton"
              className="search-button mrg-rgt"
              onClick={() => handleOkButtonClick(data, selected, okButtonClick)}
              disabled={!selected}
            >
              OK
            </button>
            <button
              name="deselectButton"
              className="search-button"
              onClick={() => this.removeRowHighlight(selected)}
              disabled={!selected}
            >
              Deselect
            </button>
          </span>
        </div>
      </div>
    );
  }
}
